import moment from 'moment-timezone';
import Swal from 'sweetalert2';


export function filterCategoriesByTime(restaurant, hours) {
    const zoneMap = {
      EST: 'America/New_York',
      CST: 'America/Chicago',
      MST: 'America/Denver',
      PST: 'America/Los_Angeles',
    };
  
    // Only use if it's a string and in our zoneMap
    const rawZone = typeof hours?.time_zone === 'string' ? hours.time_zone.trim().toUpperCase() : '';
    const timeZone = zoneMap[rawZone] || 'America/New_York'; // fallback
  
    if (!restaurant?.Categories) return restaurant;
  
    const now = moment().tz(timeZone);
    const currentDay = now.day(); // 0 (Sun) - 6 (Sat)
    const nowMoment = moment.tz(now.format('hh:mm A'), 'hh:mm A', timeZone); // safe

    const parseTime = (t) => {
      if (typeof t !== 'string' || !t.trim()) return null;
      return moment.tz(t.trim(), 'hh:mm A', timeZone);
    };
  
    const filteredCategories = restaurant.Categories.filter((cat) => {
      if (cat.always_shown) return true;
  
      const days = Array.isArray(cat.display_days) ? cat.display_days : [];
      if (!days.includes(currentDay)) {
        return false;
      }
  
      const startMoment = parseTime(cat.display_start_time);
      const endMoment = parseTime(cat.display_end_time);
  
      if (startMoment?.isValid() && endMoment?.isValid()) {
        const result = nowMoment.isSameOrAfter(startMoment) && nowMoment.isSameOrBefore(endMoment);
        return result;
      }
  
      if (startMoment?.isValid()) {
        const result = nowMoment.isSameOrAfter(startMoment);
        return result;
      }
  
      if (endMoment?.isValid()) {
        const result = nowMoment.isSameOrBefore(endMoment);
        return result;
      }
  
      // Default to show if no valid times
      return true;
    });
  
    return {
      ...restaurant,
      Categories: filteredCategories,
    };
  }

  const dayNamesMap = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  export const validateCartItemsByCategoryTime = (cartItems, restaurantCategories, hours) => {
    const timeZone = hours?.time_zone || 'EST';
    const now = moment().tz(timeZone);
    const currentDay = now.day(); // Sunday = 0
  
    const dayLabels = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
    for (let item of cartItems) {
      const categoryId = item.Item?.category_id;
      if (!categoryId) continue;
  
      const category = restaurantCategories.find(cat => cat.id === categoryId);
      if (!category || category.always_shown) continue;
  
      const { display_start_time, display_end_time, display_days = [], name } = category;
  
      // Check day validity
      const dayValid = display_days.length === 0 || display_days.includes(currentDay);
  
      // Check time validity
      const format = 'h:mm A';
      const nowFormatted = now.format(format);
      let timeValid = true;
  
      const start = display_start_time ? moment(display_start_time, format) : null;
      const end = display_end_time ? moment(display_end_time, format) : null;
  
      if (start && end) {
        timeValid = now.isBetween(start, end);
      } else if (start) {
        timeValid = now.isAfter(start);
      } else if (end) {
        timeValid = now.isBefore(end);
      }
  
      if (!dayValid || !timeValid) {
        let reason = '';
  
        if (!dayValid) {
          reason = `${name} is only available on: ${display_days.map(d => dayLabels[d]).join(', ')}`;
        } else if (!timeValid) {
          if (start && end) {
            reason = `${name} is available from ${display_start_time} to ${display_end_time}`;
          } else if (start) {
            reason = `${name} is available starting at ${display_start_time}`;
          } else if (end) {
            reason = `${name} is available until ${display_end_time}`;
          }
        }
  
        const validDays = Array.isArray(display_days) ? display_days.map((d) => dayNamesMap[d]) : [];

        Swal.fire({
          icon: 'warning',
          title: `${item.Item.name} is not available now`,
          text: dayValid && !timeValid
            ? `This item is only available from ${display_start_time || 'open'} to ${display_end_time || 'close'}`
            : !dayValid && timeValid
            ? `This item is only available on: ${validDays.join(', ')}`
            : `This item is only available on: ${validDays.join(', ')} from ${display_start_time || 'open'} to ${display_end_time || 'close'}`
        });
        return false;
      }
    }
  
    return true;
  };



export function getItemAttributeNameById(id, item) {
    // Iterate over Restaurant_Item_Attributes array
    for (const attribute of item.Restaurant_Item_Attributes) {
      // Iterate over Item_Attribute_Options array within each Item_Attribute
      for (const option of attribute.Item_Attribute.Item_Attribute_Options) {
        // Check if the id matches
        if (option.id === id) {
          return option.name; // Return the name if id matches
        }
      }
    }
    // Return null if no matching id is found
    return null;
  }
